import { useSelector } from 'react-redux';

import { FF_ADS_ON_MOBILE_WEB } from '@wetransfer/transfer/constant/experiments';
import { isPaidTransfer } from '@wetransfer/transfer/helper/paidTransfers';
import { getFullVariant } from '@wetransfer/transfer/modules/experiments';
import { selectCustomWallpaper } from '@wetransfer/transfer/store/customWallpapers';
import { selectRoutePath } from '@wetransfer/transfer/store/selector/route';
import { selectIsSessionTandC } from '@wetransfer/transfer/store/selector/session';
import { selectTransfer } from '@wetransfer/transfer/store/selector/transfer';

export function useIsMobileWebWallpaperEnabled(): boolean {
  const transfer = useSelector(selectTransfer);
  const isTermsAccepted = useSelector(selectIsSessionTandC);
  const customWallpaper = useSelector(selectCustomWallpaper);
  const routePath = useSelector(selectRoutePath);

  const isPaid = isPaidTransfer(transfer.paid);
  const isShowAdsEnabled = getFullVariant(FF_ADS_ON_MOBILE_WEB).value === 'on';

  if (
    routePath.includes('downloads') &&
    isShowAdsEnabled &&
    isTermsAccepted &&
    // Disable wallpapers for paid transfers without custom wallpapers
    !(isPaid && !customWallpaper)
  ) {
    return true;
  }

  return false;
}
